import { inject, Injectable } from '@angular/core';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CallbackContext } from '../callback-context';
import { OidcStorageService } from '../../storage/oidc-storage.service';
import { LoggerWrapper } from '../../../shared/providers/logger/logger-wrapper.service';
import { OpenIdConfiguration } from '../../oidc-security.service';
import { LoggerFactory } from '../../../shared/providers/logger/logger-factory.service';

@Injectable({ providedIn: 'root' })
export class UserCallbackHandlerService {
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this, true);

  constructor(private readonly oidcStorageService: OidcStorageService) {}

  // STEP 5 userData
  saveUserData(callbackContext: CallbackContext, config: OpenIdConfiguration): Observable<CallbackContext> {
    const { validationResult } = callbackContext;
    const userData = validationResult.decodedIdToken;
    const userEmail = userData['email'];
    const pwdLastSetLdapTimestampString = userData['custom:pwdlastset'];
    this.logger.info(userEmail + ' : sauvegarde du decodedIdToken');
    this.logger.info(userEmail + ' : pwdLastSetLdapTimestampString = ' + pwdLastSetLdapTimestampString);

    return from(this.oidcStorageService.setUserDataToStore(userData, config.type)).pipe(
      switchMap(() => {
        if (!!userData) {
          return of(callbackContext);
        } else {
          this.oidcStorageService.clear(config.type).then();
          return throwError(() => new Error(`Called for userData but they were ${userData}`));
        }
      }),
      catchError((err) => {
        let message = `Failed to retrieve user info from idToken and save with error:  ${err}`;
        this.logger.error(err, '[oidc] saveUserData', message);
        return throwError(() => new Error(message));
      })
    );
  }
}
